import { Component, Input } from '@angular/core';
import { FinancialTrend } from '../../services/finance-data.service';

@Component({
    selector: 'app-finance-trend-visualization',
    templateUrl: './finance-trend-visualization.component.html',
    styleUrls: ['./finance-trend-visualization.component.scss'],
})
export class FinanceTrendVisualizationComponent {
    @Input() financialTrend: FinancialTrend;
}
